<template>
    <select @change='selectionChanged'>
        <slot></slot>
        <!-- Modal -->
        <div ref="modalConfirmation" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog old-modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Bestätigung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Möchtest du dieses Profil wirklich löschen?
                    <p>Deine gepflegten Daten gehen hiermit unwiderruflich verloren!</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Nein</button>
                    <button @click="deleteProfile" type="button" class="btn btn-primary" data-dismiss="modal">Ja</button>
                </div>
                </div>
            </div>
        </div>
        <div ref="modalSuccess" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog old-modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Bestätigung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Dein Profil wurde gelöscht!
                </div>
                <div class="modal-footer">
                    <button @click="gotoHome" type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
                </div>
                </div>
            </div>
        </div>
    </select>
</template>

<script>
	export default {
		name: 'smallProfileNavigation',
		props: {
            profileId: String
        },
        data: function() {
        	return {
        	}
        },
        methods: {
            selectionChanged(event) {
                if (event.target.value.indexOf('delete') === 0) {
                    this.deleteProfileConfirmation();
                } else {
                    window.location.href = event.target.value;
                }
            },
            deleteProfileConfirmation: function() {
                jQuery(this.$refs.modalConfirmation).modal('show');
                return false;
            },
            deleteProfile: function() {
                var self = this;
                jQuery.ajax ({
                    url: '/profile/' + self.profileId,
                    type: 'DELETE',
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        jQuery(self.$refs.modalSuccess).modal('show');
                    },
                    error: function() {alert("error");}
                });
            },
            gotoHome: function() {
                window.location.href = '/home.html';
            }
        }
	}
</script>


// WEBPACK FOOTER //
// SmallProfileNavigation.vue?150b2021